import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "moment/locale/tr";
import "react-big-calendar/lib/css/react-big-calendar.css";
import './LessonCalendar.css'
import styled from "./LessonCalendar.module.css";
import { SubmitButton, ExitButton, CancelButton } from "../../components/styled/styledbuttons/buttons.js";
import {FaTrash, FaEdit} from "react-icons/fa"
import Navbar from "../../components/navbar/Navbar.jsx";
import { auth, db } from "../../firebase/firebase.js";
import { collection, getDocs, where, query, addDoc, doc, deleteDoc, } from "firebase/firestore";
import SelectTeacher from "./SelectTeacher.jsx"
import { fetchTeacherInfo } from "./functions.js";
import { useTeacher } from "../../context/TeacherProvider.jsx";
import { useSelector } from "react-redux";
import {
  canStudentJoinLesson,
  getLessonRoomPath,
} from "../../utils/lessonLinks.js";
import { API_BASE } from "../../config/api.js";
async function getIdToken() {
const user = auth.currentUser;
if (!user) throw new Error("Not authenticated");
return await user.getIdToken();
}


const localizer = momentLocalizer(moment);
const SLOT_DURATION_MS = 30 * 60 * 1000;

const LessonCalendar = () => {
  const { t, i18n } = useTranslation();
  const studentData = useSelector((state) => state.student.data);

  useEffect(() => {
    moment.locale(i18n.language);
  }, [i18n.language]);

  const calendarMessages = {
    date: t("Calendar.date"),
    time: t("Calendar.time"),
    event: t("Calendar.event"),
    allDay: t("Calendar.allDay"),
    week: t("Calendar.week"),
    work_week: t("Calendar.work_week"),
    day: t("Calendar.day"),
    month: t("Calendar.month"),
    previous: t("Calendar.previous"),
    next: t("Calendar.next"),
    yesterday: t("Calendar.yesterday"),
    tomorrow: t("Calendar.tomorrow"),
    today: t("Calendar.today"),
    agenda: t("Calendar.agenda"),
    noEventsInRange: t("Calendar.noEventsInRange"),
    showMore: (total) => t("Calendar.showMore", { count: total }),
  };
  // To show only the days from today and on
  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);
  // Collection References

const [calendarKey, setCalendarKey] = useState(0);

const refreshCalendar = () => {
  setCalendarKey((prevKey) => prevKey + 1); 
  // Force refresshing a calendar. 
}
const teacherCollectionRef = collection(db, "teachers")
const eventCollectionRef = collection(db, "events")
const { teacherID } = useTeacher();


  const [module, setModule] = useState(false);
  const [teacherSelected, setTeacherSelected] = useState(false)
  const [teacherName, setTeacherName] = useState("");
  const [teacherEmail, setTeacherEmail] = useState("");
  const [selectedTeacherID, setSelectedTeacherID] = useState("")
  const [teacherEvents, setTeacherEvents] = useState([])
  const [events, setEvents] = useState([]);
  const [slots, setSlots] = useState([]);
  const [stName, setStName] = useState("");
  const [timeSlotInfo, setTimeSlotInfo] = useState();

  // const [selectedEventIndex, setSelectedEventIndex] = useState(null);
 
 const fetchEventsforSelectedTeacher = async () => {
    try {
      const q = query(collection(db, "events"), where("teacherID", "==", selectedTeacherID));
      const data = await getDocs(q);
      const fetchedEvents = data.docs.map((doc) => {
        const eventData = doc.data();
        const isCurrentStudent = eventData.studentID === auth.currentUser.uid;
        return {
          id: doc.id,
          title: isCurrentStudent
          ? `${eventData.studentName} - ${eventData.teacherName}`
          : t("LessonCalendar.slotBooked"),
          start: eventData.start?.toDate(),
          end: eventData.end?.toDate(),
          isCurrentStudent 
        };
      });
      setTeacherEvents(fetchedEvents);
      setEvents(fetchedEvents); // Sync both states
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const fetchSlotsForSelectedTeacher = async () => {
    try {
    const slotQuery = query(collection(db, "slots"), where("teacherID", "==", selectedTeacherID))
    const data = await getDocs(slotQuery)
    const fetchedSlots = data.docs.map((doc) => {
      const eventData = doc.data();
      return {
        id: doc.id,
        start: eventData.start?.toDate(),
        end: eventData.end?.toDate(),
      }
    })
    setSlots(fetchedSlots)
    
    } catch (error) {
      console.error("Error fetching slots:", error);
    }
  } 

  useEffect(() => {
    if (teacherID) {
      setSelectedTeacherID(teacherID);
    }
  }, [teacherID]);

  
useEffect(() => {
  const fetchData = async () => {
    if (!selectedTeacherID) return;

    try {
      const { name, email } = await fetchTeacherInfo(selectedTeacherID);

      setTeacherName(name);
      setTeacherEmail(email);

      await fetchEventsforSelectedTeacher(selectedTeacherID);
      await fetchSlotsForSelectedTeacher(selectedTeacherID);
    } catch (error) {
      console.error("Error fetching teacher data:", error);
    }
  };

  fetchData();
}, [selectedTeacherID]);

const today = new Date();
today.setHours(0, 0, 0, 0); // Start of today

const [currentDate, setCurrentDate] = useState(today); 

const handleNavigate = (newDate, view) => {
  if (newDate >= today) {
    setCurrentDate(newDate);
  }
};


  const handleSelectSlot = (slotInfo) => {
    if (slotInfo.start < new Date()) {
      alert(t("LessonCalendar.cannotSelectPast"));
      return;
    }
    // Match by start only — stored slot ends can be off by 1s (e.g. 18:59:59 vs 19:00).
    const isAvailable = slots.some(
      (slot) => slot.start.getTime() === slotInfo.start.getTime()
    );
    if (!isAvailable) {
      alert(t("LessonCalendar.slotNotAvailable"));
      return;
    }
    const start = slotInfo.start;
    setModule(true);
    setTimeSlotInfo({
      ...slotInfo,
      start,
      end: new Date(start.getTime() + SLOT_DURATION_MS),
    });
  };

  const exitHandler = () => {
    setModule(false);
  };
  const slotPropGetter = (date) => {
    const isAvailable = slots.some(
      (slot) =>
        slot.start.getTime() === date.getTime() // Match slot times
    );
  
    if (!isAvailable) {
      return {
        style: {
          backgroundColor: "lightgray",
          pointerEvents: "none", // Disable pointer events
          cursor: "not-allowed",
        },
      };
    }
  
    return {
      style: {
        backgroundColor: "white",
      },
    };
  };
  
const submitHandler = async () => {
try {
setModule(false);


// Always book a clean 30-minute window (Daily exp uses end_time).
const start = timeSlotInfo.start;
const end = new Date(start.getTime() + SLOT_DURATION_MS);
const startISO = start.toISOString();
const endISO = end.toISOString();
const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;


const payload = {
start_time: startISO,
end_time: endISO, 
topic: `${studentData?.firstName} || ${auth?.currentUser?.displayName} - ${teacherName}`,
duration: 30,
timezone: "UTC", 
studentTimeZone,
teacherID: selectedTeacherID,
teacherName,
teacherEmail, 
studentID: auth.currentUser.uid,
studentName: `${studentData?.firstName} ${studentData?.lastName}`,
studentEmail: auth.currentUser.email

};


const idToken = await getIdToken();


const resp = await fetch(`${API_BASE}/create-zoom-meeting`, {
method: "POST",
headers: {
"Content-Type": "application/json",
Authorization: `Bearer ${idToken}`,
},
body: JSON.stringify(payload),
});

// const resp = await fetch(`http://localhost:4000/create-zoom-meeting`, {
//   method: "POST",
//   headers: {
//   "Content-Type": "application/json",
//   Authorization: `Bearer ${idToken}`,
//   },
//   body: JSON.stringify(payload),
//   });


if (!resp.ok) {
const err = await resp.json().catch(() => ({}));
throw new Error(err.error || `HTTP ${resp.status}`);
}


const createdEvent = await resp.json();

 

setEvents((prev) => [
...prev,
{
 id: createdEvent.id,
 title: createdEvent.title,
 start: new Date(createdEvent.start),
 end: new Date(createdEvent.end),
 studentName: createdEvent.studentName,
 studentID: createdEvent.studentID,
 teacherID: createdEvent.teacherID,
 teacherName: createdEvent.teacherName,
 hasVideoCall: Boolean(createdEvent.hasVideoCall),
 isCurrentStudent: true,
},
]);
refreshCalendar();
} catch (error) {
console.error("Error creating event:", error);
alert(error.message || t("LessonCalendar.bookFailed"));
}
};


const removeEvent = async (eventId, eventStartTime) => {
  const currentTime = new Date();
  const start = eventStartTime instanceof Date ? eventStartTime : new Date(eventStartTime);
  const timeDifference = start.getTime() - currentTime.getTime();

  if (timeDifference <= 2 * 60 * 60 * 1000) {
    alert("You cannot delete an event less than 2 hours before its start time.");
    return;
  }

  if (!window.confirm(t("LessonCalendar.confirmDelete"))) {
    return;
  } 

  try {
    const idToken = await getIdToken();
    const resp = await fetch(`${API_BASE}/delete-zoom-meeting/${eventId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });

    if (!resp.ok) {
      const err = await resp.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${resp.status}`);
    }
    setEvents((prev) => prev.filter((e) => e.id !== eventId));
    refreshCalendar();
    alert(t("LessonCalendar.deleteSuccess"));
  } catch (error) {
    console.error("Error deleting event:", error);
    alert(error.message || t("LessonCalendar.deleteFailed"));
  }
};

const CustomEvent = ({ event }) => (
  <div>
    <strong>{event.title}</strong>

    {event.isCurrentStudent && (
      <div>
        {canStudentJoinLesson(event) && (
          <a href={getLessonRoomPath(event.id)}>
            {t("LessonCalendar.joinLesson")}
          </a>
        )}
        <FaTrash
          className={styled.trashBin}
          onClick={() => removeEvent(event.id, event.start)}
        />
      </div>
    )}
  </div>
);

  const isMobile = window.innerWidth < 768;

  return (
    <> 
    <Navbar />
      {module && (
        <div className={styled.module}>
          <SubmitButton onClick={submitHandler}>{t("LessonCalendar.bookThisLesson")}</SubmitButton>
          <CancelButton onClick={exitHandler}>{t("LessonCalendar.cancel")}</CancelButton>
          <ExitButton onClick={exitHandler}>X</ExitButton>
        </div>
      )}

      <div className={styled.app}>
        { teacherSelected || teacherID  ? 
 
        <Calendar
          key={calendarKey}
          localizer={localizer}
          messages={calendarMessages}
          culture={i18n.language}
          defaultDate={new Date()}
          views={isMobile ? ['agenda', 'day'] : ['week', 'day', 'agenda']}
          defaultView={isMobile ? 'day' : 'week'}
          events={events}
          selectable={true}
          onSelectSlot={handleSelectSlot}
          longPressThreshold={250}
          step={30}
          timeslots={1}
          min={todayStart}
          slotPropGetter={slotPropGetter}
          onNavigate={handleNavigate}
          date={currentDate}
          style={{ height: "100vh" }}
          formats={{
            timeGutterFormat: (date, culture, localizer) =>
              localizer.format(date, "HH:mm", culture),
          }}
          components={{
            event: CustomEvent,
          }}
        /> 
        
        : 
        <SelectTeacher   setTeacherSelected={setTeacherSelected}  setSelectedTeacherID={setSelectedTeacherID} setTeacherEvents={setTeacherEvents} /> 
        }
      </div>
    </>
  );
};

export default LessonCalendar;

